import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  updateTabStatus,
  getTabStatus,
} from "../../../services/yourAssets/CommonServices";
import { getSBTextStatus } from "../../../utils/statusViewUtilities";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
const initialState = {
  assetsSuggestionBoxText: [],
  loading: false,

  error: "",
};

export const getAssetsOnBoardingList = createAsyncThunk(
  //action type string
  "assetsOnBoarding/getAssetsOnBoarding",
  // callback function
  async (thunkAPI) => {
    let uID = getUserIdFromLocalStorage();
    const suggestionBoxTextList = await getSBTextStatus(getTabStatus, uID);
    return suggestionBoxTextList;
  }
);

export const assetsOnBoardingSlice = createSlice({
  name: "assetsOnBoarding",
  initialState,
  reducers: {
    visited: (state, action) => {
      let id = action.payload;

      let indexOfState = state.assetsSuggestionBoxText.findIndex(
        (el) => el.id === id
      );
      if (indexOfState >= 0) {
        state.assetsSuggestionBoxText[indexOfState].status = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAssetsOnBoardingList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAssetsOnBoardingList.fulfilled, (state, action) => {
      state.loading = false;
      state.assetsSuggestionBoxText = action.payload;
      state.error = "";
    });
    builder.addCase(getAssetsOnBoardingList.rejected, (state, action) => {
      state.loading = false;
      state.assetsSuggestionBoxText = [];
      state.error = action.error.message;
    });
  },
});

export default assetsOnBoardingSlice.reducer;
export const { visited } = assetsOnBoardingSlice.actions;
